export const LOGIN_MODE = {
  INTEGRADO_ERP: 1,
  GUARDIAN: 2,
  AZURE_AD: 3,
  SAML: 4
};